import {
    clickContextualBannerDismiss,
    clickToggleOff,
    clickToggleOn,
    impressionContextualBanner,
    impressionToggleSwitch,
} from "@cart-client/analytics/events";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import { useCallback, useContext } from "react";

export function useIncognitoModeAnalytics(cartId: string) {
    const { clickEvent, impressionEvent } = useContext(AnalyticsContext);

    const CONSTANTS = {
        INCOGNITO: "incognito",
        HALF_CARD: "half-card",
        POSITION: "vertical-widget-position",
    };

    const onImpressionContextualBanner = useCallback(
        (isEnabled: boolean) => {
            if (!cartId) return;
            impressionContextualBanner(
                impressionEvent,
                cartId,
                JSON.stringify({ uniqueIdentifier: CONSTANTS.INCOGNITO, autoDismiss: false, isEnabled }),
            );
        },
        [cartId, impressionEvent],
    );

    const onClickContextualBannerDismiss = useCallback(() => {
        if (!cartId) return;
        clickContextualBannerDismiss(
            clickEvent,
            cartId,
            JSON.stringify({ uniqueIdentifier: CONSTANTS.INCOGNITO, autoDismiss: false }),
        );
    }, [cartId, clickEvent]);

    const onImpressionToggleSwitch = useCallback(
        (isEnabled: boolean) => {
            if (!cartId) return;
            impressionToggleSwitch(
                impressionEvent,
                cartId,
                CONSTANTS.POSITION,
                JSON.stringify({ toggleIdentifier: CONSTANTS.INCOGNITO, isEnabled }),
            );
        },
        [cartId, impressionEvent],
    );

    const onClickToggleHandler = useCallback(
        (isEnabled: boolean) => {
            if (!cartId) return;
            !isEnabled
                ? clickToggleOn(
                      clickEvent,
                      cartId,
                      CONSTANTS.POSITION,
                      JSON.stringify({ toggleIdentifier: CONSTANTS.INCOGNITO, isEnabled }),
                  )
                : clickToggleOff(
                      clickEvent,
                      cartId,
                      CONSTANTS.POSITION,
                      JSON.stringify({ toggleIdentifier: CONSTANTS.INCOGNITO, isEnabled }),
                  );
        },
        [cartId, clickEvent],
    );

    return {
        onImpressionContextualBanner,
        onClickContextualBannerDismiss,
        onImpressionToggleSwitch,
        onClickToggleHandler,
    };
}
